export enum PriceTypeEnum {
  MONTHLY = 'monthly',
  PAY_NOW = 'paynow'
}

